import isomorphicFetch from 'isomorphic-fetch';
import fetchRetry from 'fetch-retry';

const fetch = fetchRetry(isomorphicFetch);

export const DEFAULT_RETRY_DELAY_FN = attempt => (2 ** attempt) * 1000; // 1000, 2000, 4000

export const DEFAULT_OPTIONS = {
    retry: 3,
    retryDelay: DEFAULT_RETRY_DELAY_FN,
    credentials: 'same-origin',
    method: 'GET'
};

export const fetchProvider = (url, options = {}) => {
    const fetchOptions = {
        ...DEFAULT_OPTIONS,
        ...options
    };

    return fetch(url, fetchOptions).then(response => {
        if (!response.ok) {
            throw new Error(`status ${response.status}, statusText: ${response.statusText}`);
        }

        return response.json();
    });
};
